/** Boards (and related rows) sometimes use numeric `id` in JSON; UI keys and WS merges need a stable string. */
export function coerceKanbanEntityId(value: unknown): string | null {
  if (typeof value === 'string') {
    const t = value.trim();
    return t.length > 0 ? t : null;
  }
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  if (typeof value === 'bigint') return String(value);
  return null;
}
